var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckedCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.75.75v1.5h4.5V.75h1.5v1.5h3a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H1.25A.75.75 0 0 1 .5 15V3a.75.75 0 0 1 .75-.75h3V.75zM14 6H2v8.25h12zm-3.723 1.602 1.06 1.06-3.712 3.713-2.652-2.652 1.062-1.06 1.59 1.591 2.653-2.652z"
})));
export default SvgCheckedCalendar;